import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'uikit/Button';

import styles from './Multi.module.scss';

const cx = classNames.bind(styles);

const Multi = ({
  className,
  handleClear,
  handleQuestionsDelete,
  handleQuestionsDuplicate,
  handleQuestionsMove,
  t,
}) => (
  <div className={className}>
    <Button
      className={cx('action')}
      icon="arrow-square-right"
      onClick={handleQuestionsMove}
      tooltip={t('Course/Teacher/Editor/Multi/move-questions')}
    />
    <Button
      className={cx('action')}
      icon="copy"
      onClick={handleQuestionsDuplicate}
      tooltip={t('Course/Teacher/Editor/Multi/duplicate-questions')}
    />
    <Button
      className={cx('action')}
      icon="trash-alt"
      onClick={handleQuestionsDelete}
      tooltip={t('Course/Teacher/Editor/Multi/delete-questions')}
      variant="regular"
    />
    <Button
      className={cx('action')}
      icon="times"
      onClick={handleClear}
      tooltip={t('Course/Teacher/Editor/Multi/clear')}
    />
  </div>
);

Multi.propTypes = {
  className: PropTypes.string,
  handleClear: PropTypes.func.isRequired,
  handleQuestionsDelete: PropTypes.func.isRequired,
  handleQuestionsDuplicate: PropTypes.func.isRequired,
  handleQuestionsMove: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

Multi.defaultProps = {
  className: undefined,
};

export default Multi;
